/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingPeriodInformation {
    getFixupPrototypeFunction() { return BillingPeriodInformation.fixupPrototype; }

    static newInstance(model: Partial<BillingPeriodInformation>): BillingPeriodInformation {
        let obj = Object.assign(new BillingPeriodInformation(), model);
        BillingPeriodInformation.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingPeriodInformation>): BillingPeriodInformation {
        if (!model) return null;
        return BillingPeriodInformation.newInstance(<BillingPeriodInformation> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingPeriodInformation) {
        if (!obj) return;

        models.BillingPeriodInformation.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingPeriodInformation): boolean {
        Object.setPrototypeOf(obj, BillingPeriodInformation.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.billing_period_start === "string") {
            this.billing_period_start = new Date(<string><any>this.billing_period_start);
        }
        if (typeof this.billing_period_end === "string") {
            this.billing_period_end = new Date(<string><any>this.billing_period_end);
        }
    }

    /**
     * The start date of the billing period
     */
    billing_period_start: Date;

    /**
     * The end date of the billing period
     */
    billing_period_end: Date;

    /**
     * Invoices for the period
     */
    invoice_ids: Array<string>;

}
